import { Link } from 'react-router-dom'
import Logo from '../images/logo.png'
import { FaFacebookSquare, FaInstagramSquare } from 'react-icons/fa'
import { ImMail } from 'react-icons/im'
import './footer.css'

const Footer = () => {
  return (
    <footer className="footer">
        <div className="container footer__container">
            <section className="footer__lcc">
                <h4>Reverend</h4>
                <h3>Gabriela Marginean</h3>
                <h4>Life Cycle Celebrant™</h4>
                <Link to="http://www.celebrantinstitute.org" >
                    <img src="http://www.celebrantinstitute.org/logo/life-cycleLogo-5-2010.gif" alt="Celebrant Foundation and Institute" />
                </Link>
                <h4>Esteemed Alumni<br />of the<br />Celebrant Foundation & Institute</h4>
            </section>
            <section className="footer__">
                <Link to="/" className="logo">
                    <img src={Logo} alt="Be-Loved-Ceremonies Logo" />
                </Link>
                <h4>Be Loved Ceremonies</h4>
                <p>Creating unique and personalized celebrations from the Sea to the Sky and anywhere else they are needed.</p>
                <div className="footer__socials">
                    <a href="https://www.facebook.com/people/Be-Loved-Ceremonies/61559051985834/" target="_blank" rel="noreferrer noopener"><FaFacebookSquare /></a>
                    <a href="https://www.instagram.com/be.loved.ceremonies/" target="_blank" rel="noreferrer noopener"><FaInstagramSquare /></a>
                    <a href="info@belovedceremonies.ca" taget="_blank" rel="noreferrer noopener"><ImMail /></a>
                </div>
            </section>
            <section className="footer__contact">
                <h4>Contact Gabi</h4>
                <Link to="/about">More Info</Link>
                <Link to="/pricing">The Experience</Link>
                <Link to="/contact">Reach Out!</Link>
            </section>
            {/* tutorial 2:55:16 for filler link section details */}
        </div>
        <div className="footer__copyright">
            <small> &copy;2024 Be Loved Ceremonies</small>
        </div>
    </footer>
  )
}

export default Footer